import React from 'react';
import dayjs from 'dayjs';
import { Table } from 'semantic-ui-react';
import { isNullOrUndefined } from '../../utils/siteFunctions';

const AccountsReport = ({ accountsReportRows }: AccountsReportProps) => {
	return (
		<>
			{accountsReportRows.length > 0 && (
				<Table celled>
					<Table.Header>
						<Table.Row>
							<Table.HeaderCell>Account #</Table.HeaderCell>
							<Table.HeaderCell>Name</Table.HeaderCell>
							<Table.HeaderCell>Creditor</Table.HeaderCell>
							<Table.HeaderCell>Entered</Table.HeaderCell>
							<Table.HeaderCell>Status</Table.HeaderCell>
							<Table.HeaderCell>Balance</Table.HeaderCell>
						</Table.Row>
					</Table.Header>
					<Table.Body>
						{accountsReportRows.map((x, index) => (
							<Table.Row key={index}>
								<Table.Cell>{x.caseFileNumber}</Table.Cell>
								<Table.Cell>{x.debtorName}</Table.Cell>
								<Table.Cell>{x.creditorName}</Table.Cell>
								<Table.Cell>{dayjs(x.enteredDate).format('M/D/YYYY')}</Table.Cell>
								<Table.Cell>{x.status}</Table.Cell>
								<Table.Cell>{!isNullOrUndefined(x.currentBalance) ? `$${x.currentBalance}` : ''}</Table.Cell>
							</Table.Row>
						))}
					</Table.Body>
				</Table>
			)}
		</>
	);
};

export interface AccountsReportProps {
	accountsReportRows: AccountsReportRow[];
}

export interface AccountsReportRow {
	caseFileNumber: string;
	enteredDate: Date;
	debtorName: string;
	address: string | null;
	clientClaimNumber: string | null;
	clientName: string;
	creditorName: string | null;
	currentBalance: number | null;
	caseClosedReason: string | null;
	status: string;
}

export default AccountsReport;